export const GET_LIST_PROVINCES = 'GET_LIST_PROVINCES';
export const GET_LIST_DISTRICTS = 'GET_LIST_DISTRICTS';
export const GET_LIST_WARDS = 'GET_LIST_WARDS';
